/* Home only: native video dialog and progressive, reduced-motion-aware reveals. */
(() => {
  const reveal = (root = document) => {
    if (Shopify.designMode || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({target, isIntersecting}) => {
        if (!isIntersecting) return;
        target.classList.add('wearse-reveal-visible');
        observer.unobserve(target);
      });
    }, {threshold: 0.08});
    root.querySelectorAll('[data-wearse-reveal]:not(.wearse-reveal-ready)').forEach(el => {
      // Content already in view never waits for an animation to become legible.
      if (el.getBoundingClientRect().top < innerHeight) return;
      el.classList.add('wearse-reveal-ready');
      observer.observe(el);
    });
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-wearse-video-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.wearseVideoOpen);
      if (!dialog) return;
      const video = dialog.querySelector('video');
      if (!video.src) video.src = video.dataset.videoSrc;
      dialog.showModal();
      video.play().catch(() => {});
    }
    const close = event.target.closest('[data-wearse-video-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.wearse-home-video')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches('.wearse-home-video')) event.target.querySelector('video')?.pause();
  }, true);
  reveal();
  document.addEventListener('shopify:section:load', event => reveal(event.target));
})();
